import "./Layout.css";
import { css } from "emotion";
import { Box, Button } from "gestalt";
import {
  CommandButton,
  Image,
  Layer,
  MessageBar,
  MessageBarType,
} from "office-ui-fabric-react";
import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { Dispatch } from "redux";
import { appActions, isOnlineSelector } from "../store/app.store";
import { RootState } from "../store/index.store";
import { uiActions } from "../store/ui.store";
import { Employee } from "../types/types";
import { Loading } from "./Loading";
import { msalInstance } from "../App";
import { useMsal } from "@azure/msal-react";
import { useAuth } from "../hooks/useAuth";

export interface LayoutProps {
  /* State */
  isOnline: boolean;
  isLoading: boolean;
  showMessageBar: boolean;
  messageBarMessage: string;
  /* Action */
  SYSTEM_HIDE_MESSAGE_BAR: () => void;
  onLogoutButtonClick: () => void;
}

const Layout: React.FunctionComponent<LayoutProps> = (props) => {
  const { isOnline, onLogoutButtonClick } = props;
  const { isLoggedIn, loginUser } = useAuth();

  useEffect(() => {
    if (props.showMessageBar) {
      setTimeout(() => {
        props.SYSTEM_HIDE_MESSAGE_BAR();
      }, 2000);
    }
  });

  if (!isLoggedIn) {
    return <h1>ログインしてください。</h1>;
  }

  return (
    <>
      <Loading isLoading={props.isLoading} />
      <Layer>
        <CSSTransition
          in={props.showMessageBar}
          timeout={{ enter: 500, exit: 300 }}
          classNames={"message-bar"}
          unmountOnExit={true}
        >
          <div
            className={css`
              background: #ffffff;
            `}
          >
            <MessageBar
              messageBarType={MessageBarType.success}
              onDismiss={props.SYSTEM_HIDE_MESSAGE_BAR}
              dismissButtonAriaLabel="Close"
            >
              {props.messageBarMessage}
            </MessageBar>
          </div>
        </CSSTransition>
      </Layer>
      <Box height={"100vh"} display={"flex"} direction={"column"}>
        <div>
          <Box
            dangerouslySetInlineStyle={{
              __style: { backgroundColor: "rgb(0, 120, 212)" },
            }}
            padding={3}
            display="flex"
            direction="row"
            alignItems="center"
            justifyContent="between"
            height={"60px"}
          >
            <Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  src="logo.png"
                  style={{
                    height: "35px",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Patua One, cursive",
                    fontSize: 25,
                    color: "white",
                    marginTop: "2px",
                    marginLeft: "5px",
                  }}
                >
                  アサイン表
                </span>
              </div>
            </Box>

            {!isOnline && (
              <Box>
                <MessageBar messageBarType={MessageBarType.warning}>
                  オフライン状態のため更新処理は利用できません
                </MessageBar>
              </Box>
            )}
            <Box paddingX={2}>
              <div className={"login-user-button"}>
                <CommandButton
                  text={loginUser?.name}
                  iconProps={{
                    iconName: "Contact",
                  }}
                  menuProps={{
                    shouldFocusOnMount: true,
                    items: [
                      {
                        key: "logout",
                        text: "ログアウト",
                        iconProps: { iconName: "OutOfOffice" },
                        onClick: () => {
                          msalInstance.logoutRedirect();
                        },
                      },
                    ],
                  }}
                />
              </div>
            </Box>
          </Box>
        </div>
        <Box>{props.children}</Box>
      </Box>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isOnline: isOnlineSelector(state),
  isLoading: state.ui.isLoading,
  showMessageBar: state.ui.showMessageBar,
  messageBarMessage: state.ui.messageBarMessage,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  // noinspection JSUnusedGlobalSymbols
  return {
    onLogoutButtonClick: () =>
      dispatch(appActions.USER_CLICKED_LOGOUT_BUTTON()),
    SYSTEM_HIDE_MESSAGE_BAR: () =>
      dispatch(uiActions.SYSTEM_HIDE_MESSAGE_BAR()),
  };
};

export const LayoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);
